import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";
import moment from "moment";
import Instructions from "./Step1Instructions";
import { Text } from "react-internationalization";
const ie =
  navigator.userAgent.indexOf("MSIE") > -1 ||
  navigator.userAgent.indexOf("rv:") > -1;

class Step1 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formerEmpOfSharp: false,
      phoneLabel:"HM"
    };
    this.validator = new SimpleReactValidator();
  }
  static getDerivedStateFromProps(nextProps) {
    let selectedPlan = nextProps.selectedPlan;
    console.log(selectedPlan);
    if (
      selectedPlan === "SDAB20" ||
      selectedPlan === "SDABWD20" ||
      selectedPlan === "SDAP20" ||
      selectedPlan === "SDAPWD20"
    ) {
      return { formerEmpOfSharp: true };
    }
  }

  /*async componentWillReceiveProps(nextProps) {
    let selectedPlan = nextProps.selectedPlan;
    console.log(selectedPlan);
    if (
      selectedPlan === "SDAB20" ||
      selectedPlan === "SDABWD20" ||
      selectedPlan === "SDAP20" ||
      selectedPlan === "SDAPWD20"
    ) {
      await this.setState({ formerEmpOfSharp: true });
    }
  }*/

  handlePhoneLabel=async(e)=>{
let value= e.target.value?e.target.value:e.value
console.log(value)
await this.setState({
  phoneLabel:value
})
}  
render() {
    const { data, selectedPlan, year } = this.props;
    const { formerEmpOfSharp } = this.state;
    return (
      <React.Fragment>
        <div class="tab-content tab-contentSharp">
          <div id="step1" class="container tab-pane active">
          
            {(year === "2022" || year === "2023") &&
            (selectedPlan === "SDAGCWD20" ||
            selectedPlan === "SDABCWD20" ||
              selectedPlan === "SDAGC20" ||
              selectedPlan === "SDAPC20" || selectedPlan ==="SDAHMO20" || selectedPlan ==="SDAHMO200"
              )? (
              <React.Fragment>
                <Instructions selectedPlan={selectedPlan} />
                <br />
                <h3 class="tab-heading">
                  <Text id="app.STEP1" /> – <Text id="app.stepSub" />
                </h3>
              </React.Fragment>
            ) :null}
             {(year === "2022" || year==="2023")&& 
            (
              selectedPlan === "SDAB20"||
              selectedPlan === "SDABWD20"||
              selectedPlan === "SDAP20"||
              selectedPlan === "SDAPWD20") ? (
              <React.Fragment>
               <Instructions selectedPlan={selectedPlan} />
                <br />
                <h3 class="tab-heading">
                  <Text id="app.STEP1" /> : <Text id="app.PERSONALINFO" />
                </h3>
              </React.Fragment>
            ) :null}
             {( year==="2021")&& 
            (
              selectedPlan === "SDAB20"||
              selectedPlan === "SDABWD20"||
              selectedPlan === "SDAP20"||
              selectedPlan === "SDAPWD20") ? (
              <React.Fragment>
              
                <h3 class="tab-heading">
                  <Text id="app.STEP1" /> : <Text id="app.PERSONALINFO" />
                </h3>
              </React.Fragment>
            ) :null}
            <div class="form-panel">
              <p>
                <strong>
                  <Text id="app.APara" />:
                </strong>
              </p>
              {selectedPlan === "SDAHMO1" || selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200"? (
                <>
                  <div class="radio radio-tab">
                    <label for="sandiego" class="control-label">
                      <Text id="app.san"/>*
                    </label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input
                      type="radio"
                      name="retiree"
                      id="retireey"
                      value="Y"
                      checked={data.retiree === "Y"}
                      onChange={this.props.handleChange}
                    />
                    <label for="sandiego" class="radio-sandiego-retiree">
                    <Text id="app.Yes" />
                    </label>
                    <input
                      type="radio"
                      name="retiree"
                      id="retireen"
                      value="N"
                      checked={data.retiree === "N"}
                      onChange={this.props.handleChange}
                    />
                    <label for="sandiego" class="radio-sandiego-retiree">
                      No
                    </label>
                  </div>
                  {data.retiree === "Y" ? (

                    <>
                   {selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200"?
                   <>
                   <div class="radio radio-tab">
                        <label
                          for="medicareEligible"
                          class="control-label"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <Text id="app.san9"/>
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          type="radio"
                          name="medicareEligible"
                          id="medicareEligibleY"
                          value="Y"
                          checked={data.medicareEligible === "Y"}
                          onChange={this.props.handleChange}
                        />{" "}
                        <label
                          for="medicareEligibletY"
                          class="radio-sandiego-retiree"
                        >
                        <Text id="app.Yes" />
                        </label>
                        <input
                          type="radio"
                          name="medicareEligible"
                          id="medicareEligibleN"
                          value="N"
                          checked={data.medicareEligible === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="medicareEligibleN"
                          class="radio-sandiego-retiree"
                        >
                          {" "}
                          No
                        </label>
                        <label class="control-label">
                         <Text id={(selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200")?"app.san10":"app.san2"}/>
                        </label>
                        {selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200"?
                        <label class="control-label">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                        
                        <Text id="app.san11"/>                         
                        </label>
                        :null}
                      </div>
                   {data.medicareEligible==="Y"?
                   <div class="radio radio-tab">
                        <label
                          for="coveringSpouseOrDependent"
                          class="control-label"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;If
                          <Text id="app.san1"/>
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          type="radio"
                          name="coveringSpouseOrDependent"
                          id="coveringSpouseOrDependentY"
                          value="Y"
                          checked={data.coveringSpouseOrDependent === "Y"}
                          onChange={this.props.handleChange}
                        />{" "}
                        <label
                          for="coveringSpouseOrDependent"
                          class="radio-sandiego-retiree"
                        >
                        <Text id="app.Yes" />
                        </label>
                        <input
                          type="radio"
                          name="coveringSpouseOrDependent"
                          id="coveringSpouseOrDependentN"
                          value="N"
                          checked={data.coveringSpouseOrDependent === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="coveringSpouseOrDependent"
                          class="radio-sandiego-retiree"
                        >
                          {" "}
                          No
                        </label>
                        <label class="control-label">
                         <Text id="app.san2"/>
                        </label>
                      </div>
                      :null}
                   </>
                   :
                      <div class="radio radio-tab">
                        <label
                          for="coveringSpouseOrDependent"
                          class="control-label"
                        >
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;If
                          <Text id="app.san1"/>
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input
                          type="radio"
                          name="coveringSpouseOrDependent"
                          id="coveringSpouseOrDependentY"
                          value="Y"
                          checked={data.coveringSpouseOrDependent === "Y"}
                          onChange={this.props.handleChange}
                        />{" "}
                        <label
                          for="coveringSpouseOrDependent"
                          class="radio-sandiego-retiree"
                        >
                        <Text id="app.Yes" />
                        </label>
                        <input
                          type="radio"
                          name="coveringSpouseOrDependent"
                          id="coveringSpouseOrDependentN"
                          value="N"
                          checked={data.coveringSpouseOrDependent === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="coveringSpouseOrDependent"
                          class="radio-sandiego-retiree"
                        >
                          {" "}
                          No
                        </label>
                        <label class="control-label">
                         <Text id="app.san2"/>
                        </label>
                      </div>}

                      {data.coveringSpouseOrDependent === "Y" ? (
                        <>
                          <div class="surviving-spouse-city-SanDiego-retiree">
                            <label class="control-label">
                             <Text id="app.san3"/>:{" "}
                            </label>
                          </div>

                          <div class="surviving-spouse-city-SanDiego-retiree">
                            <div class="col-md-3">
                              <label for="lastName" class="control-label">
                                <Text id="app.LastName"/>:
                              </label>
                              <input
                                type="text"
                                id="coveringSpouseOrDependentLastName"
                                class={"form-control"}
                                value={data.coveringSpouseOrDependentLastName}
                                onChange={this.props.handleChange}
                                name="coveringSpouseOrDependentLastName"
                              />
                            </div>
                            <div class="col-md-3">
                              <label for="firstName" class="control-label">
                                <Text id="app.FirstName" />
                              </label>
                              <input
                                type="text"
                                id="coveringSpouseOrDependentFirstName"
                                name="coveringSpouseOrDependentFirstName"
                                value={data.coveringSpouseOrDependentFirstName}
                                onChange={this.props.handleChange}
                                class={"form-control"}
                              />
                            </div>
                            <div class={this.props.lang==="es"?"col-md-4":"col-md-3"}>
                              <label for="middleInitial" class="control-label">
                                <Text id="app.MiddleInitial"/>:
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                value={data.coveringSpouseOrDependentMiddleName}
                                onChange={this.props.handleChange}
                                id="coveringSpouseOrDependentMiddleName"
                                name="coveringSpouseOrDependentMiddleName"
                              />
                            </div>
                          </div>
                          <br />
                          <br />
                          {selectedPlan !=="SDAHMO20" || selectedPlan !== "SDAHMO200"?
                          <div class="radio radio-tab">
                            <p class="medicare-note">
                              <strong><Text id="app.NOTE"/>: </strong>
                              <Text id="app.san6"/>.
                            </p>
                          </div>
                          :""}
                        </>
                      ) : data.coveringSpouseOrDependent === "N" ? (
                        <div class="surviving-spouse-city-SanDiego-retiree">
                          <div class="col-md-9">
                            <label class="control-label">
                             <Text id="app.san4"/>:
                            </label>
                            <br />
                            <input
                              type="text"
                              class="form-control"
                              name="coveringSpouseOrDependentEmployeeName"
                              id="coveringSpouseOrDependentEmployeeNameId"
                              value={data.coveringSpouseOrDependentEmployeeName}
                              onChange={this.props.handleChange}
                            />
                          </div>
                        </div>
                      ) : null}
                    </>
                  ) : data.retiree === "N" ? (
                    <div class="radio radio-tab">
                      <label
                        for="survivingSpouseCitySanDiegoRetiree"
                        class="control-label"
                      >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                        <Text id="app.san7"/>
                      </label>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <input
                        type="radio"
                        name="survivingSpouseCitySanDiegoRetiree"
                        id="survivingSpouseCitySanDiegoRetireeY"
                        value="Y"
                        checked={
                          data.survivingSpouseCitySanDiegoRetiree === "Y"
                        }
                        onChange={this.props.handleChange}
                      />{" "}
                      <label
                        for="survivingSpouseCitySanDiegoRetiree"
                        class="radio-sandiego-retiree"
                      >
                        <Text id="app.Yes" />
                      </label>
                      <input
                        type="radio"
                        name="survivingSpouseCitySanDiegoRetiree"
                        id="survivingSpouseCitySanDiegoRetireeN"
                        value="N"
                        checked={
                          data.survivingSpouseCitySanDiegoRetiree === "N"
                        }
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="survivingSpouseCitySanDiegoRetiree"
                        class="radio-sandiego-retiree"
                      >
                        {" "}
                        No
                      </label>
                      {data.survivingSpouseCitySanDiegoRetiree === "Y" ? (
                        <>
                          <div class="surviving-spouse-city-SanDiego-retiree">
                            <div class="col-md-3">
                              <label for="lastName" class="control-label">
                                <Text id="app.rtlast"/>:
                              </label>
                              <input
                                type="text"
                                id="survivingSpouseCitySanDiegoRetireeLastName"
                                class={"form-control"}
                                value={
                                  data.survivingSpouseCitySanDiegoRetireeLastName
                                }
                                onChange={this.props.handleChange}
                                name="survivingSpouseCitySanDiegoRetireeLastName"
                              />
                            </div>
                            <div class="col-md-3">
                              <label for="firstName" class="control-label">
                                <Text id="app.rtfirst"/>:
                              </label>
                              <input
                                type="text"
                                id="survivingSpouseCitySanDiegoRetireeFirstName"
                                name="survivingSpouseCitySanDiegoRetireeFirstName"
                                value={
                                  data.survivingSpouseCitySanDiegoRetireeFirstName
                                }
                                onChange={this.props.handleChange}
                                class={"form-control"}
                              />
                            </div>
                            <div class="col-md-3">
                              <label for="middleInitial" class="control-label">
                                <Text id="app.rtmiddle"/>:
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                value={
                                  data.survivingSpouseCitySanDiegoRetireeMiddleName
                                }
                                onChange={this.props.handleChange}
                                id="survivingSpouseCitySanDiegoRetireeMiddleName"
                                name="survivingSpouseCitySanDiegoRetireeMiddleName"
                              />
                            </div>
                          </div>
                          <br />
                          <br />
                          {(selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200")?"":
                          <div class="radio radio-tab">
                            <p class="medicare-note">
                              <strong><Text id="app.NOTE"/>: </strong><Text id="app.san8"/>.
                            </p>
                          </div>}
                        </>
                      ) : null}
                    </div>
                  ) : null}
                </>
              ) : null}

              {formerEmpOfSharp ||
              selectedPlan === "SDAHMO1" ||
              selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200"? (
                <div class="form-group row">
                  <div
                    class={this.props.lang === "es" ? "col-md-4" : "col-md-3"}
                  >
                    <label for="effDate" class="control-label">
                      <Text id="app.Effectdate" />*
                    </label>
                    <input
                      class={
                        data.effDate === "" ||
                        !moment(data.effDate, "MM/DD/YYYY", true).isValid()
                          ? "error-input"
                          : "form-control"
                      }
                      maxLength="10"
                      value={data.effDate}
                      onChange={this.props.handleDate}
                      onClick={(e) => this.props.handleDates("effDate")}
                      name="effDate"
                      id="effDate"
                      placeholder="MM/DD/YYYY"
                      required=""
                    />
                  </div>
                  {formerEmpOfSharp ? (
                    <div class="col-md-3">
                      <label for="ssn" class="control-label">
                        <Text id="app.Socialnumber" />*
                      </label>
                      <input
                        type="text"
                        id="ssn"
                        name="ssn"
                        value={data.ssn}
                        onChange={this.props.handleNumberChange}
                        class={data.ssn.length !=9 ? "error-input" : "form-control"}
                        required=""
                        maxLength="9"
                      />
                    </div>
                  ) : null}
                </div>
              ) : null}
              <div class="form-group row">
                <div class={this.props.lang === "es" ? "col-md-4" : "col-md-3"}>
                  <fieldset class={ie ? "radio iemargin3" : "radio"}>
                    <legend>
                      <Text id="app.Prefix" />
                    </legend>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="mr"
                        name="prefix"
                        class="custom-control-input"
                        value="mr"
                        checked={data.prefix === "mr" ? true : false}
                        onChange={this.props.handleChange}
                      />
                      <label for="mr" class="radio-inline custom-control-label">
                        <Text id="app.Mr" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="mrs"
                        name="prefix"
                        class="custom-control-input"
                        value="mrs"
                        checked={data.prefix === "mrs" ? true : false}
                        onChange={this.props.handleChange}
                      />
                      <label
                        for="mrs"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Mrs" />
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="ms"
                        name="prefix"
                        class="custom-control-input"
                        value="ms"
                        checked={data.prefix === "ms" ? true : false}
                        onChange={this.props.handleChange}
                      />
                      <label for="ms" class="radio-inline custom-control-label">
                        <Text id="app.Ms" />
                      </label>
                    </div>
                  </fieldset>
                </div>
                <div class="col-md-3">
                  <label for="firstName" class="control-label">
                    <Text id="app.FirstName" />
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={data.firstName}
                    onChange={this.props.handleChange}
                    class={
                      data.firstName === "" ? "error-input" : "form-control"
                    }
                    required=""
                  />
                </div>

                <div class="col-md-3">
                  <label for="lastName" class="control-label">
                    <Text id="app.LastName" />
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    class={
                      data.lastName === "" ? "error-input" : "form-control"
                    }
                    value={data.lastName}
                    onChange={this.props.handleChange}
                    name="lastName"
                    required=""
                  />
                </div>
                <div class={this.props.lang==="es"?"col-md-4":"col-md-3"}>
                  <label for="middleInitial" class="control-label">
                    <Text id="app.MI" />
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={data.middleInitial}
                    onChange={this.props.handleChange}
                    id="middleInitial"
                    name="middleInitial"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-3">
                  <label for="birthDate" class="control-label">
                    <Text id="app.BirthDate" />
                  </label>
                  <input
                    class={
                      data.birthDate === "" ||
                      !moment(data.birthDate, "MM/DD/YYYY", true).isValid()
                        ? "error-input"
                        : "form-control"
                    }
                    value={data.birthDate}
                    maxLength="10"
                    onChange={this.props.handleDate}
                    onClick={(e) => this.props.handleDates("birthDate")}
                    name="birthDate"
                    id="birthDate"
                    placeholder="MM/DD/YYYY"
                    required=""
                  />
                </div>
                <div class="col-md-3">
                  <fieldset
                    class={ie ? "radio radio-tab iemargin" : "radio radio-tab"}
                  >
                    <legend
                      class={ data.sex ?"control-label":"invalid-date"}
                    >
                      <Text id="app.Sex" />
                    </legend>
                    <div class={
                        this.props.lang==="es"
                          ? "custom-control custom-radio custom-control-inline sp_step1margin "
                          : "custom-control custom-radio custom-control-inline"
                      }>
                      <input
                        type="radio"
                        value="M"
                        checked={data.sex === "M"}
                      onChange={(e) => {
                        this.props.handleChange(e);
                      }}
                        name="sex"
                        id="male"
                        class="custom-control-input"
                        style={{ zIndex: -2 }}
                      />
                      <label
                        for="male"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Male" />
                      </label>
                    </div>
                    <div
                      class={
                        this.props.lang==="es"
                          ? "custom-control custom-radio custom-control-inline sp_step1margin "
                          : "custom-control custom-radio custom-control-inline"
                      }
                    >
                      <input
                        type="radio"
                        value="F"
                        name="sex"
                        checked={data.sex === "F"}
                      onChange={(e) => {
                        this.props.handleChange(e);
                      }}
                        id="female"
                        class="custom-control-input"
                        style={{ zIndex: -2 }}
                      />
                      <label
                        for="female"
                        class="radio-inline custom-control-label"
                      >
                        <Text id="app.Female" />
                      </label>
                    </div>
                  </fieldset>
                </div>
                {this.props.year === "2023" && 
                 (this.props.selectedPlan === "SDAGCWD20" ||
                 this.props.selectedPlan === "SDAGC20" ||
                 this.props.selectedPlan === "SDABCWD20" ||
                 this.props.selectedPlan === "SDAPC20"||formerEmpOfSharp)?
                 <>
                {// <div class="col-md-3">
                //   <label for="primaryPhone" class="control-label">
                //     <select style={{border:"none",background:"none"}} onChange={this.handlePhoneLabel} value={phoneLabel}>
                //       <option value="cl">Cell Phone Number</option>
                //       <option value="HM">Home Phone Number</option>
                //       <option value="oth">Other Phone Number</option>
                //     </select>
                //   </label>
                //   <input
                //     type="text"
                //     id="primaryPhone"
                //     value={phoneLabel==="cl"?data.alternatePhone:phoneLabel==="HM"?
                //            data.primaryPhone :data.otherPhone}
                //     onChange={this.props.handleChange}
                //     name={phoneLabel==="cl"?"alternatePhone":phoneLabel==="HM"?
                //     "primaryPhone" :"otherPhone"}
                //     class={phoneLabel==="HM"?
                //       data.primaryPhone === "" ||
                //       data.primaryPhone.indexOf("(") === -1 ||
                //       data.primaryPhone.indexOf(")") === -1
                //         ? "error-input"
                //         : "form-control":"form-control"}
                //     placeholder="(   )   -"
                //     required=""
                //     maxLength="14"
                //   />
                // </div>
              }
                <div class="col-md-3">
                    <label for="alternatePhone" class="control-label">
                      <Text id="app.CellPhoneNumber" />
                    </label>
                    <input
                      type="text"
                      id="alternatePhone"
                      name="alternatePhone"
                      value={data.alternatePhone}
                      onChange={this.props.handleChange}
                      class="form-control"
                      placeholder="(   )   -"
                      maxLength="14"
                    />
                  </div>
                <div class="col-md-3">
                <label for="primaryPhone" class="control-label">
                  <Text id="app.HomeNumber" />
                  
                </label>
                <input
                  type="text"
                  id="primaryPhone"
                  value={data.primaryPhone}
                  onChange={this.props.handleChange}
                  name="primaryPhone"
                  class={
                    data.primaryPhone === "" ||
                    data.primaryPhone.indexOf("(") === -1 ||
                    data.primaryPhone.indexOf(")") === -1
                      ? "error-input"
                      : "form-control"
                  }
                  placeholder="(   )   -"
                  required=""
                  maxLength="14"
                />
              </div>
              <div class="col-md-3">
                  <label for="OtherPhone" class="control-label">
                    <Text id="app.OtherPhoneNumber" />
                  </label>
                  <input
                    type="text"
                    id="OtherPhone"
                    value={data.otherPhone}
                    onChange={this.props.handleChange}
                    name="otherPhone"
                    class="form-control"
                    placeholder="(   )   -"
                    maxLength="14"
                  />
                </div>
              </>
                :<div class="col-md-3">
                <label for="primaryPhone" class="control-label">
                  <Text id="app.PrimaryPhoneNumber" />
                  
                </label>
                <input
                  type="text"
                  id="primaryPhone"
                  value={data.primaryPhone}
                  onChange={this.props.handleChange}
                  name="primaryPhone"
                  class={
                    data.primaryPhone === "" ||
                    data.primaryPhone.indexOf("(") === -1 ||
                    data.primaryPhone.indexOf(")") === -1
                      ? "error-input"
                      : "form-control"
                  }
                  placeholder="(   )   -"
                  required=""
                  maxLength="14"
                />
              </div> }
                {!(
                 (this.props.year === "2022"  || this.props.year === "2023") && 
                  (this.props.selectedPlan === "SDAGCWD20" ||
                    this.props.selectedPlan === "SDAGC20" ||
                    this.props.selectedPlan === "SDABCWD20" ||
                    this.props.selectedPlan === "SDAPC20" || formerEmpOfSharp)
                ) ? (
                  <div class="col-md-3">
                    <label for="alternatePhone" class="control-label">
                      <Text id="app.CellPhoneNumber" />
                    </label>
                    <input
                      type="text"
                      id="alternatePhone"
                      name="alternatePhone"
                      value={data.alternatePhone}
                      onChange={this.props.handleChange}
                      class="form-control"
                      placeholder="(   )   -"
                      maxLength="14"
                    />
                  </div>
                ) : null}
              </div>
              {this.props.selectedPlan === "SDAHMO200"  && 
              <div class="form-group row">
              <div class="col-md-3">
                  <label for="OtherPhone" class="control-label">
                    <Text id="app.OtherPhoneNumber" />
                  </label>
                  <input
                    type="text"
                    id="OtherPhone"
                    value={data.otherPhone}
                    onChange={this.props.handleChange}
                    name="otherPhone"
                    class="form-control"
                    placeholder="(   )   -"
                    maxLength="14"
                  />
                </div>
                </div>
              }
              {(this.props.year==="2023"  && this.props.selectedPlan !=="SDAHMO200")
              ?<>
              <div class="form-group row">
                    
              <div class="col-md-12">
                    <label for="clinicName" class="control-label">
                      <Text id="step2.Email" />
                      :
                    </label>
                    <input
                      type="text"
                      id="emailAddr"
                      name="emailAddr"
                      value={data.emailAddr}
                      onChange={this.props.handleChange}
                      class="form-control"
                    />
                    {/* <div class="checkbox checkbox-tab mt-1">
                      <div class="custom-control custom-checkbox custom-control-inline ml-0">
                        <input
                          type="checkbox"
                          checked={data.emailAlert === "Y" ? true : false}
                          id="emailAlert"
                          name="emailAlert"
                          defaultChecked
                          class="custom-control-input"
                          onChange={this.props.handleChange}
                        />
                        <label for="emailAlert" class="custom-control-label"> 
                          <Text id="app.news" />. 
                        </label>
                        
                      </div>
                    </div> */}
                  </div>
                  </div>

                    </>:null}
              <div class="form-group row">
                <div class="col-md-12">
                  <label for="permanentAddrStreet" class="control-label">
                    <Text id="app.PermanentAddress" />{" "}
                    <strong>
                      (<Text id="app.POBox" />
                      )*
                    </strong>
                  </label>
                  <input
                    type="text"
                    name="permanentAddrStreet"
                    id="permanentAddrStreet"
                    value={data.permanentAddrStreet}
                    onChange={this.props.handleChange}
                    class={
                      data.permanentAddrStreet === ""
                        ? "error-input"
                        : "form-control"
                    }
                    required=""
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-3">
                  <label for="permanentCity" class="control-label">
                    <Text id="app.City" />*
                  </label>
                  <input
                    type="text"
                    class={
                      data.permanentCity === "" ? "error-input" : "form-control"
                    }
                    value={data.permanentCity}
                    onChange={this.props.handleChange}
                    name="permanentCity"
                    id="permanentCity"
                    required=""
                  />
                </div>

                <div class="col-md-3">
                  <label for="permanentCounty" class="control-label">
                    <Text id="app.County" />
                  </label>
                  <input
                    type="text"
                    style={{ cursor: "not-allowed" }}
                    class="form-control"
                    name="permanentCounty"
                    id="permanentCounty"
                    value={data.permanentCounty}
                    disabled
                  />
                </div>

                <div class="col-md-3">
                  <label for="permanentState" class="control-label">
                    <Text id="app.State" />
                  </label>
                  <input
                    type="text"
                    style={{ cursor: "not-allowed" }}
                    class="form-control"
                    name="permanentState"
                    id="permanentState"
                    value="CA"
                    disabled
                  />
                </div>

                <div class="col-md-3">
                  <label for="permanentZip" class="control-label">
                    <Text id="app.ZIPCode" />*
                  </label>
                  <input
                    type="text"
                    class={
                      data.permanentZip.length < 5
                        ? "error-input"
                        : "form-control"
                    }
                    name="permanentZip"
                    id="permanentZip"
                    minlength="5"
                    value={data.permanentZip}
                    onChange={this.props.handleNumberChange}
                    maxLength="5"
                    required=""
                  />
                </div>
              </div>
              <div class="form-group">
                    <div
                      style={{
                        display: ie ? "inline-flex" : "",
                      }}
                    >
                      <label for="language" class="control-label mr-2">
                        <Text id="app.mailingaddress" />
                      </label>
                      <div class="custom-control custom-checkbox custom-control-inline mt-3">
                        <input
                          type="checkbox"
                          name="mailingAddressRequired"
                          id="mailingAddressRequired"
                          class="custom-control-input"
                          checked={data.mailingAddressRequired === "YES"}
                          onChange={this.props.handleCheckbox2}
                        />
                        <label
                          for="mailingAddressRequired"
                          class="radio-inline custom-control-label"
                          style={{
                            marginTop: ie ? "0px" : "auto",
                          }}
                        >
                          <strong><Text id="app.Yes" /></strong>
                        </label>
                      </div>
                    </div>
                  </div>
                  {this.props.data.mailingAddressRequired === "YES" ? (
                    <div id="mailing-adddress">
                      <div class="form-group row">
                        <div class="col-md-12">
                          <label for="mailingAddr" class="control-label">
                            <Text id="app.maillingAdd" />*
                          </label>
                          <input
                            type="text"
                            class={
                              data.mailingAddr === ""
                                ? "error-input"
                                : "form-control"
                            }
                            value={data.mailingAddr}
                            onChange={this.props.handleChange}
                            name="mailingAddr"
                            id="mailingAddr"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-md-3">
                          <label for="mailingCity" class="control-label">
                            <Text id="app.City" />*
                          </label>
                          <input
                            type="text"
                            class={
                              data.mailingCity === ""
                                ? "error-input"
                                : "form-control"
                            }
                            value={data.mailingCity}
                            onChange={this.props.handleChange}
                            name="mailingCity"
                            id="mailingCity"
                            required=""
                          />
                        </div>
                        <div class="col-md-3">
                          <label
                            for="mailingState"
                            style={{ marginTop: "1em" }}
                          >
                            <Text id="app.State" />
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            name="mailingState"
                            id="mailingState"
                            value={data.mailingState}
                           // onChange={this.props.handleChange}
                            disabled
                          />
                        </div>
                        <div class="col-md-3">
                          <label for="mailingzip" class="control-label">
                            <Text id="app.ZIPCode" />*
                          </label>
                          <input
                            type="text"
                            class={
                              data.mailingzip === ""
                                ? "error-input"
                                : "form-control"
                            }
                            name="mailingzip"
                            id="mailingzip"
                            minlength="5"
                            value={data.mailingzip}
                            onChange={this.props.handleChange}
                            maxLength="5"
                            required=""
                          />
                        </div>
                      </div>
                     
                    </div>
                  ) : null}
                   {((this.props.year==="2022" || this.props.year==="2023") &&
                      this.props.selectedPlan==="SDABCWD20"||
                      this.props.selectedPlan==="SDAGC20"||
                      this.props.selectedPlan==="SDAGCWD20"||
                      this.props.selectedPlan==="SDAPC20")?(
                        <div class="form-group row">
                        <div class="col-md-6">
                          <p>
                            <label for="medicareClaim" class="control-label">
                              <Text id="app.MedicareNo" />*
                            </label>
                            <input
                              type="text"
                              // pattern="/[a-zA-Z0-9]{10,11}/"
                              placeholder="XXXXXXXXXXX"
                              name="medicareClaim"
                              id="medicareClaim"
                              minlength="11"
                              maxLength="13"
                              class={
                                data.medicareClaim === "" ||
                                (data.medicareClaim &&
                                  data.medicareClaim.length < 11)
                                  ? "error-input"
                                  : "form-control"
                              }
                              value={data.medicareClaim}
                              onChange={this.props.handleChange}
                              required=""
                            />
                          </p>
                        </div>
                      </div>
                      ):null}
                      
                    
                    {(year==="2022")  && (selectedPlan === "SDAB20" ||
                  selectedPlan === "SDABWD20"||
                  selectedPlan === "SDAP20"||
                  selectedPlan === "SDAPWD20"|| selectedPlan === "SDAHMO200")?
                  (
                    <React.Fragment>
                 
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label for="emailAddr" class="control-label">
                        <Text id="app.email" />
                      </label>
                      <input
                        type="email"
                        id="emailAddr"
                        name="emailAddr"
                        value={data.emailAddr}
                        onChange={this.props.handleChange}
                        class="form-control"
                        required=""
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div
                      class="col-md-12"
                      style={{
                        display: formerEmpOfSharp ? "flex" : "none",
                      }}
                    >
                      <div class="checkbox checkbox-tab">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input
                            type="checkbox"
                            id="shpmp"
                            name="shpmp"
                            class="custom-control-input"
                            checked={data.shpmp === "Y"}
                            onChange={this.props.handleChange}
                          />
                          <label for="shpmp" class="custom-control-label">
                            <strong>
                              <Text id="app.Please" />.
                            </strong>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="checkbox checkbox-tab">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input
                            type="checkbox"
                            checked={data.emailAlert === "Y"}
                            id="emailAlert"
                            name="emailAlert"
                            defaultChecked
                            class="custom-control-input"
                            onChange={this.props.handleChange}
                          />
                          <label for="emailAlert" class="custom-control-label">
      
                              <strong>
                                <Text id="app.news" />.
                              </strong>
                            
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
                  )
                  :null}
              {!(
                year === "2022" || year === "2023"   &&
                (selectedPlan === "SDAGCWD20" ||
                  selectedPlan === "SDAGC20" ||
                  selectedPlan === "SDAPC20"||
                  selectedPlan === "SDABCWD20"||
                  selectedPlan === "SDAB20" ||
                  selectedPlan === "SDABWD20"||
                  selectedPlan === "SDAP20"||
                  selectedPlan === "SDAPWD20")||
                  (year==="2021" && (selectedPlan === "SDAGCWD20" ||
                  selectedPlan === "SDAGC20" ||
                  selectedPlan === "SDAPC20"||
                  selectedPlan === "SDABCWD20"))
              ) ? (
                <React.Fragment>
                 
                  <div class="form-group row">
                    <div class="col-md-12">
                      <label for="emailAddr" class="control-label">
                        <Text id="app.email" />
                      </label>
                      <input
                        type="email"
                        id="emailAddr"
                        name="emailAddr"
                        value={data.emailAddr}
                        onChange={this.props.handleChange}
                        class="form-control"
                        required=""
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <div
                      class="col-md-12"
                      style={{
                        display: formerEmpOfSharp ? "flex" : "none",
                      }}
                    >
                      <div class="checkbox checkbox-tab">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input
                            type="checkbox"
                            id="shpmp"
                            name="shpmp"
                            class="custom-control-input"
                            checked={data.shpmp === "Y"}
                            onChange={this.props.handleChange}
                          />
                          <label for="shpmp" class="custom-control-label">
                            <strong>
                              <Text id="app.Please" />.
                            </strong>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="checkbox checkbox-tab">
                        <div class="custom-control custom-checkbox custom-control-inline">
                          <input
                            type="checkbox"
                            checked={data.emailAlert === "Y"}
                            id="emailAlert"
                            name="emailAlert"
                            defaultChecked
                            class="custom-control-input"
                            onChange={this.props.handleChange}
                          />
                          <label for="emailAlert" class="custom-control-label">
                            {selectedPlan === "SDAHMO1" ||
                            selectedPlan === "SDAHMO20" || selectedPlan === "SDAHMO200"? (
                              <strong>
                               <Text id="app.news1" />
                              </strong>
                            ) : (
                              <strong>
                                <Text id="app.news" />.
                              </strong>
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                {!(year==="2022"|| year==="2023" && selectedPlan === "SDAB20" ||
                  selectedPlan === "SDABWD20"||
                  selectedPlan === "SDAP20"||
                  selectedPlan === "SDAPWD20"||
                  selectedPlan === "SDABCWD20"||
                  selectedPlan === "SDAGC20"||
                  selectedPlan === "SDAGCWD20"||
                  selectedPlan === "SDAPC20")?(
                  <div class="form-group row">
                    <div class="col-md-6">
                      <p>
                        <label for="medicareClaim" class="control-label">
                          <Text id="app.MedicareNo" />*
                        </label>
                        <input
                          type="text"
                          pattern="/[a-zA-Z0-9]{10,11}/"
                          placeholder="XXXXXXXXXXX"
                          name="medicareClaim"
                          id="medicareClaim"
                          minlength="10"
                          maxLength="13"
                          class={
                            data.medicareClaim === "" ||
                            (data.medicareClaim &&
                              data.medicareClaim.length < 10)
                              ? "error-input"
                              : "form-control"
                          }
                          value={data.medicareClaim}
                          onChange={this.props.handleChange}
                          required=""
                        />
                      </p>
                    </div>
                  </div>
                  ):null}
                  {(
                  (this.props.year === "2022" ||  this.props.year === "2023") &&
                  (this.props.selectedPlan === "SDAGCWD20" ||
                    this.props.selectedPlan === "SDAGC20" ||
                    this.props.selectedPlan === "SDABCWD20" ||
                    this.props.selectedPlan === "SDAPC20")
                ) ? (
                  <div class="form-group row" style={{ marginLeft: "4px" }}>
                    <fieldset
                      class="radio radio-tab mt-3"
                      id="c_qns1"
                      name="c_qns1"
                      onChange={this.props.handleChange}
                      value={data.c_qns1}
                    >
                      <legend>
                        <Text id="app.drugCoverage" />{" "}
                      </legend>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          name="vaBenefits"
                          id="c_q2_yes"
                          class="custom-control-input"
                          value="Y"
                          checked={data.vaBenefits === "Y"?true:false}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="c_q2_yes"
                          class="radio-inline custom-control-label"
                        >
                          <Text id="app.Yes" />
                        </label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          name="vaBenefits"
                          id="c_q2_no"
                          class="custom-control-input"
                          value="N"
                          checked={data.vaBenefits === "N"}
                          onChange={this.props.handleChange}
                        />
                        <label
                          for="c_q2_no"
                          class="radio-inline custom-control-label"
                        >
                          <Text id="app.No" />
                        </label>
                      </div>
                    </fieldset>
                  </div>):null}
                  {(this.props.selectedPlan !== "SDAB20" &&
                this.props.selectedPlan !== "SDABWD20" &&
                this.props.selectedPlan !== "SDAP20" &&
                this.props.selectedPlan !== "SDAPWD20") && data.vaBenefits === "Y" ? (
                    <div class="row mt-3 mb-2">
                      <div class="col-md-4">
                        <label for="nameOfCov" class="control-label">
                          <Text id="app.coverage" /> * :
                        </label>
                        <input
                          type="text"
                          class={
                            data.nameOfCov === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="nameOfCov"
                          name="nameOfCov"
                          value={data.nameOfCov}
                          onChange={this.props.handleChange}
                        />
                      </div>
                      <div class="col-md-4">
                        <label
                          for="idOfCov"
                          class="control-label"
                          style={{ width: "356px" }}
                        >
                          <Text id="app.mebernumber" />
                          *:
                        </label>
                        <input
                          type="text"
                          class={
                            data.idOfCov === "" ? "error-input" : "form-control"
                          }
                          id="idOfCov"
                          name="idOfCov"
                          value={data.idOfCov}
                          onChange={this.props.handleChange}
                        />
                      </div>
                      <div class="col-md-4">
                        <label for="groupOfCov" class="control-label">
                          <Text id="app.groupNo" /> * :
                        </label>
                        <input
                          type="text"
                          class={
                            data.groupOfCov === ""
                              ? "error-input"
                              : "form-control"
                          }
                          id="groupOfCov"
                          name="groupOfCov"
                          value={data.groupOfCov}
                          onChange={this.props.handleChange}
                        />
                      </div>
                    </div>
                  ) : null}
                 {this.props.selectedPlan !== "SDAHMO200"?(
                  <div class="card">
                    <h3 class="card-header block-heading">
                      <Text id="app.imp" /> : <Text id="app.impsub" />
                    </h3>
                    <div class="panel">
                      <div class="card-body">
                      <ul>  
                       {
                  
                  (this.props.selectedPlan === "SDAB20" ||
                    this.props.selectedPlan === "SDABWD20" ||
                    this.props.selectedPlan === "SDAP20" ||
                    this.props.selectedPlan === "SDAPWD20")
                 ? (
                    <>  
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li><Text id="app.imp1" />.</li>
                  </>
                ):(
                 
                        
                        <li>
                            <Text id="app.imp1" />.
                          </li>
                    
                )}     
                          <li>
                            <Text id="app.imp2" />.
                          </li>
                          <li>
                            <Text id="app.imp3" />.
                          </li>
                          <li>
                            <Text id="app.imp4" />.
                          </li>
                          <li>
                            <Text id="app.imp5" />.
                          </li>
                          <li>
                            <Text id="app.imp6" />.
                          </li>
                        
                        {this.props.year==="2022"||this.props.year==="2023"?(
                          <li>
                           
                            <Text id="app.imp7" />:{" "}
                            <br/>
                             
                            <Text id="app.imp7sub1"/>
                            <br/>
                            <Text id="app.imp7sub2"/>.
                            
                          </li>
                        ):null}

                        {this.props.year==="2023"?
                        <li> <Text id="app.imp10" /></li>
                       :null}
                        <br/>
                        </ul>
                      </div>
                    </div>
                  </div>):""}
                  <div>
                  {((year  == "2022" && selectedPlan !== "SDAHMO200" ) && selectedPlan === "SDAB20" ||
                  selectedPlan === "SDABWD20"||
                  selectedPlan === "SDAP20"||
                  selectedPlan === "SDAPWD20" )?(
                    <div>
                    <p></p>
                  <h4 class="mb-3 text-center">
                    <Text id="step4.accept"/>
                                  </h4>
                   </div>
                  ):null}
                  </div>
                  {selectedPlan !== "SDAHMO200"?
                  <div class="form-group row">         
                    <div class="col-md-4">
                      <label for="nameSignature" class="control-label">
                        <Text id="app.Name" />*
                      </label>
                      <input
                        type="text"
                        id="nameSignature"
                        name="nameSignature"
                        value={data.nameSignature}
                        onChange={this.props.handleChange}
                        class={
                          this.props.data.nameSignature === ""
                            ? "error-input"
                            : "form-control"
                        }
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="nameSignature" class="control-label">
                        <Text id="app.DigitalSignature" />
                      </label>
                      <input
                        type="text"
                        id="nameSignature"
                        name="nameSignature"
                        disabled="true"
                        style={{ cursor: "not-allowed" }}
                        value={data.nameSignature}
                        onChange={this.props.handleChange}
                        class={"form-control"}
                      />
                    </div>
                    <div class="col-md-4">
                      <label for="todaysDate" class="control-label">
                        <Text id="app.TodayDate" />
                      </label>
                      <input
                        type="text"
                        style={{ cursor: "not-allowed" }}
                        id="todaysDate"
                        name="todaysDate"
                        disabled="true"
                        value={data.todaysDate}
                        onChange={this.props.handleChange}
                        class={"form-control"}
                      />
                    </div>
                    <div class="col-md-12">
                      <fieldset
                        class="radio radio-tab mt-3"
                        id="authorizedrep_radio"
                      >
                        <legend>
                          <Text id="app.authorizedrepresentative" />{" "}
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            name="AuthorizedRep"
                            id="authorizedRepresentative_Y"
                            class="custom-control-input"
                            value="Y"
                            onChange={this.props.handleChange}
                            checked={data.AuthorizedRep === "Y" ? true : false}
                          />
                          <label
                            for="authorizedRepresentative_Y"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.Yes" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            name="AuthorizedRep"
                            id="authorizedRepresentative_no"
                            class="custom-control-input"
                            value="N"
                            onChange={this.props.handleChange}
                          />
                          <label
                            for="authorizedRepresentative_no"
                            class="radio-inline custom-control-label"
                            checked={data.AuthorizedRep === "N" ? true : false}
                          >
                            No
                          </label>
                        </div>
                      </fieldset>
                      <div class="form-group">
                        <strong>
                          <Text id="app.authorized" />:
                        </strong>
                      </div>
                      {data.AuthorizedRep === "Y" ? (
                        <React.Fragment>
                          <div class="row mt-3">
                            <div class="col-md-6">
                              <label
                                class="control-label"
                                for="authorizedrepname"
                              >
                                <Text id="app.Name" />*
                              </label>
                              <input
                                type="text"
                                class={
                                  this.props.data.authorizedrepname === ""
                                    ? "error-input"
                                    : "form-control"
                                }
                                name="authorizedrepname"
                                id="authorizedrepname"
                                required=""
                                value={data.authorizedrepname}
                                onChange={this.props.handleChange}
                              />
                            </div>
                            <div class="col-md-6">
                              <label
                                class="control-label"
                                for="authorizedreprelationship"
                              >
                                <Text id="app.Enrollee" />*
                              </label>
                              <select
                                name="authorizedreprelationship"
                                id="authorizedreprelationship"
                                class={
                                  this.props.data.authorizedreprelationship ===
                                  ""
                                    ? "error-input"
                                    : "form-control"
                                }
                                value={data.authorizedreprelationship}
                                onChange={this.props.handleChange}
                              >
                                {this.props.authorizedrelations.map(
                                  (item, i) => {
                                    return (
                                      <option
                                        class="select-option"
                                        value={item.value}
                                        key={i}
                                      >
                                        {item.label}
                                      </option>
                                    );
                                  }
                                )}
                              </select>
                            </div>
                          </div>
                          <div class="row mt-3">
                            <div class="col-md-8">
                              <label
                                class="control-label"
                                for="authorizedRepAddr"
                              >
                                <Text id="app.address" />*
                              </label>
                              <input
                                type="text"
                                class={
                                  this.props.data.authorizedrepaddress === ""
                                    ? "error-input"
                                    : "form-control"
                                }
                                id="authorizedRepAddr"
                                name="authorizedrepaddress"
                                value={data.authorizedrepaddress}
                                onChange={this.props.handleChange}
                                required=""
                              />
                            </div>
                            <div class="col-md-4">
                              <label
                                class="control-label"
                                for="authorizedrepphone"
                              >
                                <Text id="app.phno" />*
                              </label>
                              <input
                                type="text"
                                id="authorizedrepphone"
                                value={data.authorizedrepphone}
                                onChange={this.props.handleChange}
                                name="authorizedrepphone"
                                class={
                                  data.authorizedrepphone === "" ||
                                  data.authorizedrepphone.indexOf("(") === -1 ||
                                  data.authorizedrepphone.indexOf(")") === -1
                                    ? "error-input"
                                    : "form-control"
                                }
                                placeholder="(   )   -"
                                required=""
                                maxLength="14"
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      ) : null}
                      <fieldset
                        class="radio radio-tab mt-3"
                        id="licensed_sales_representative_radio"
                      >
                        <legend>
                          <Text id="app.License" />
                        </legend>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            name="AgentAssistingEnrollment"
                            id="licensedSalesRepresentative_Y"
                            class="custom-control-input"
                            value="Y"
                            onChange={this.props.handleChange}
                            checked={
                              data.AgentAssistingEnrollment === "Y"
                                ? true
                                : false
                            }
                          />
                          <label
                            for="licensedSalesRepresentative_Y"
                            class="radio-inline custom-control-label"
                          >
                            <Text id="app.Yes" />
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            name="AgentAssistingEnrollment"
                            id="licensedSalesRepresentative_no"
                            class="custom-control-input"
                            value="N"
                            onChange={this.props.handleChange}
                          />
                          <label
                            for="licensedSalesRepresentative_no"
                            class="radio-inline custom-control-label"
                          >
                            No
                          </label>
                        </div>
                      </fieldset>
                      {data.AgentAssistingEnrollment === "Y" ? (
                        <React.Fragment>
                          <div class="row">
                            <div class="col-md-6">
                              <label
                                class="control-label"
                                for="salesRepresentativeName"
                              >
                                <Text id="app.sale" />*
                              </label>
                              <input
                                type="text"
                                class={
                                  this.props.data.nameAgent === ""
                                    ? "error-input"
                                    : "form-control"
                                }
                                name="nameAgent"
                                id="salesRepresentativeName"
                                required=""
                                onChange={this.props.handleChange}
                                value={data.nameAgent}
                              />
                            </div>
                            <div class="col-md-6">
                              <label
                                class="control-label"
                                for="salesRepresentativeLicenseNumber"
                              >
                                <Text id="app.Licenseno" />
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                name="agentLicense"
                                id="salesRepresentativeLicenseNumber"
                                required=""
                                onChange={this.props.handleChange}
                                value={data.agentLicense}
                              />
                            </div>
                          </div>
                        </React.Fragment>
                      ) : null}
                    </div>
                  </div>:""}
                </React.Fragment>
              )}
                             
              <p class="medicare-note">
                <strong>
                  <Text id="app.NOTE" />:
                </strong>{" "}
                <Text id="app.notePart" />.
              </p>
              <button
                class="btn btn-saveNext"
                id="next1"
                onClick={this.props.redirect}
              >
                <Text id="app.Save_Next" />
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    year: state.webApp.year,
    lang: state.webApp.language,
  };
};
export default connect(mapStateToProps)(Step1);
